/* eslint-disable prettier/prettier */
import axios from '/components/configs/axios'
import { useAuthContext } from '../../../providers/authProvider'

const navigation = () => {
  const { loggedIn, setLoggedIn, seIsAgent, setUser } = useAuthContext()

  const logout = async () => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${loggedIn}`
    }

    await axios
      .post('auth/logout', '', {
        headers: headers
      })
      .then(() => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('isAgent')
        setLoggedIn(false)
        seIsAgent(false)
        setUser(false)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  return [
    {
      title: {
        en: 'Vacation Rentals',
        fr: 'Locations saisonnières',
        es: 'Alquileres de vacaciones',
        nl: 'vakantiewoningen'
      },
      links: [
        {
          title: 'St. Martin Destination',
          link: '/vacation-rentals?location=terres-basses&location=grand-case&location=happy-bay&location=orient-bay'
        },
        {
          title: 'St. Maarten Destination',
          link: '/vacation-rentals?location=cupecoy&location=indigo-bay&location=pelican&location=simpson-bay'
        },
        {
          title: 'Exclusive Properties',
          link: '/vacation-rentals?homeType=exclusive'
        },
        {
          title: 'Beachfront Properties',
          link: '/vacation-rentals?amenities=beachfront'
        },
        {
          title: 'Villas',
          link: '/vacation-rentals?homeType=villa'
        },
        {
          title: 'Condos',
          link: '/vacation-rentals?homeType=condominium'
        },
        {
          title: 'Calendar',
          link: '/calendar'
        }
      ]
    },
    {
      title: {
        en: 'Real Estate',
        fr: 'Immobilier',
        es: 'Bienes raíces',
        nl: 'Vastgoed'
      },
      links: [
        {
          title: 'Buy and Sell with Us',
          link: '/real-estate'
        },
        {
          title: "Exclusive St Martin Sotheby's Realty",
          link: '/real-estate/search?homeType=exclusive'
        }
      ]
    },
    {
      title: {
        en: 'Company',
        fr: 'Entreprise',
        es: 'Compañía',
        nl: 'Bedrijf'
      },
      links: [
        {
          title: 'Guest Experience',
          link: '/guest-experience'
        },
        {
          title: 'About Us',
          link: '/about-us'
        },
        {
          title: 'FAQs',
          link: '/frequently-asked-questions'
        },
        {
          title: 'Stories',
          link: '/stories'
        },
        !loggedIn && {
          title: 'Login',
          link: '/login'
        },
        !loggedIn && {
          title: 'Register',
          link: '/register'
        },
        loggedIn && {
          title: 'Logout',
          action: () => logout()
        }
      ]
    },
    {
      title: {
        en: 'Contact',
        fr: 'contacter',
        es: 'contactar',
        nl: 'communicatie'
      },
      links: [
        {
          title: 'Contact Us',
          link: '/contact'
        },
        {
          title: 'Privacy Policy',
          link: '/privacy-policy'
        },
        {
          title: 'Terms of Use',
          link: '/terms'
        },
        {
          title: 'Sitemap',
          link: '#',
          disabled: true
        }
      ]
    },
    {
      title: {
        en: 'Socials',
        fr: 'réseaux sociaux',
        es: 'Sociales',
        nl: 'Sociaal'
      },
      links: [
        {
          title: 'Facebook',
          social: true,
          link: 'https://www.facebook.com/stmartinsothebysrealty/'
        },
        {
          title: 'Twitter',
          social: true,
          link: 'https://twitter.com/SXMSIR'
        },
        {
          title: 'Instagram',
          social: true,
          link: 'https://www.instagram.com/sxmsir'
        },
        {
          title: 'LinkedIn',
          social: true,
          link: 'https://www.linkedin.com/company/stmartinsothebysrealty'
        },
        {
          title: 'YouTube',
          social: true,
          link: 'https://www.youtube.com/channel/UCjnr48kipvnQZnxPiSlluLQ'
        }
      ]
    }
  ]
}
export default navigation
